import { withInstall } from '@ll-plus/utils'

import PaginationPro from './src/pagination-pro.vue'

export const LlPaginationPro = withInstall(PaginationPro)

export * from './src/pagination-pro'

declare module 'vue' {
  export interface GlobalComponents {
    LlPaginationPro: typeof PaginationPro
  }
}
